import type { MutableRefObject } from 'react'

import type {
  ModalDeviceReplacementFormProps,
  ModalDeviceReplacementFormSchema,
} from 'Components/ModalDeviceReplacementForm/ModalDeviceReplacementForm.types'
import type { ModalSummaryProps } from 'Components/ModalSummary/ModalSummary.types'
import type { ShippingAddressFormSchema } from 'Components/ShippingAddressForm/ShippingAddressForm.types'

import type { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'

export enum ReplaceBrokenDeviceModalStepsEnum {
  LANDING = 'LANDING',
  SHIPPING = 'SHIPPING',
  REPLACEMENT_FORM = 'REPLACEMENT_FORM',
  SUMMARY = 'SUMMARY',
  CONFIRMATION = 'CONFIRMATION',
}

export interface ReplaceBrokenDeviceModalStepsMap {
  [key: string]: {
    component: React.FunctionComponent<any>
    props:
      | ReplaceBrokenDeviceLandingProps
      | ReplaceBrokenDeviceShippingFormProps
      | ModalDeviceReplacementFormProps
      | ModalSummaryProps
      | ReplaceBrokenDeviceConfirmationProps
  }
}

export interface ReplaceBrokenDeviceModalProps {
  rental: getRental_rental
  isShown: boolean
  isReplaceFromDepot: boolean
  onClose: () => void
  onSubmit: () => void
  setOnAfterClose: (onAfterClose: () => void) => void
}

export interface ReplaceBrokenDeviceLandingProps {
  isReplacementDeviceAvailableInDepot: boolean
  hasChildRentals: boolean
  onSetCurrentStep: (step: `${ReplaceBrokenDeviceModalStepsEnum}`) => void
  heading?: JSX.Element
}

export interface ReplaceBrokenDeviceShippingFormProps {
  isFirstStep: boolean
  rental: getRental_rental
  shippingFormData: ShippingAddressFormSchema | null
  onPreviousStep: () => void
  onSetCurrentStep: (
    step: `${ReplaceBrokenDeviceModalStepsEnum}`,
    shippingData?: ShippingAddressFormSchema,
    replacementData?: ModalDeviceReplacementFormSchema,
  ) => void
  heading?: JSX.Element
}

export interface ReplaceBrokenDeviceConfirmationProps {
  isTelekomTheme: boolean
  requestIdRef: MutableRefObject<string | null>
  onClose: () => void
  closeButtonE2ESelector?: string
}
